var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchoolGehennaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "688.000000pt",
    height: "624.000000pt",
    viewBox: "0 0 688.000000 624.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,624.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1758 4907 c-97 -111 -289 -330 -427 -487 -138 -157 -251 -288 -251         -291 0 -3 192 -147 428 -320 235 -172 497 -365 582 -428 215 -158 262 -193         533 -391 l237 -174 0 -483 0 -482 741 -556 c407 -306 742 -555 743 -553 2 2         -107 154 -241 338 -134 184 -329 452 -433 595 -104 143 -243 334 -309 425 -66         91 -121 167 -121 170 0 3 30 39 68 81 37 42 140 159 229 262 90 102 170 192         178 201 14 13 3 24 -102 100 -65 47 -467 338 -893 648 l-775 564 -5 491 -5         492 -177 -202z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2745 4830 c-137 -156 -281 -320 -319 -365 -39 -44 -121 -138 -184         -208 -63 -70 -113 -129 -111 -131 2 -2 47 -35 99 -73 199 -146 638 -469 705         -518 39 -28 225 -166 415 -305 190 -139 393 -289 452 -333 l108 -79 2 -489 3         -489 177 202 c97 112 292 334 432 493 l255 290 -22 20 c-13 11 -413 304 -890         650 l-867 630 -2 495 -3 494 -250 -284z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3754 4768 c-165 -188 -358 -408 -427 -487 -70 -80 -127 -148 -127         -152 0 -4 118 -94 263 -200 144 -106 303 -223 352 -259 50 -37 279 -205 510         -375 231 -170 471 -346 533 -392 l112 -83 442 2 441 3 -674 489 c-371 270         -739 538 -819 596 -80 58 -180 131 -222 161 l-77 54 -3 493 -3 494 -301 -344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5054 5051 c-53 -63 -728 -835 -778 -888 l-30 -33 432 0 432 0 2 490         c2 270 0 490 -3 490 -4 0 -29 -26 -55 -59z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolGehennaIcon);
export default __webpack_public_path__ + "static/media/schoolGehennaIcon.0f6e0a00e66c5d001050ff6c2f14e5d5.svg";
export { ForwardRef as ReactComponent };